import { getTheme, Icon, IStyle, ITheme, mergeStyleSets } from '@fluentui/react';
import React from 'react';
import { BwjPalette } from '../../../app-theme';

interface IPRIVATE_PANEL_DISPLAY_BUTTONProps {
  title: string;
  onClick: () => void;
}

const getStyles = (theme: ITheme) => {

  const buttonContainer: IStyle = {
    fontSize: theme.fonts.medium.fontSize,
    backgroundColor: theme.palette.neutralPrimary,
    borderTopLeftRadius: '0.25em',
    borderBottomLeftRadius: '0.25em',
    height: '100%',
  };

  const main: IStyle = {
    all: 'unset',
    padding: 0,
    paddingLeft: 25,
    paddingRight: 15,
    height: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: BwjPalette.themeSuccess,
    color: theme.palette.white,
    opacity: 0.9,
    borderTopLeftRadius: '0.25em',
    borderBottomLeftRadius: '0.25em',

    '&:focus': {
      outline: `1px dashed ${theme.palette.white}`,
    },
    '&:hover': {
      opacity: 0.75,
    },
    '&:active': {
      opacity: 1,
    }
  };

  const icon: IStyle = {
    fontSize: '2em',
  };
  
  return mergeStyleSets({
    buttonContainer,
    main,
    icon,
  });
};

export const PRIVATE_PANEL_DISPLAY_BUTTON: React.FunctionComponent<IPRIVATE_PANEL_DISPLAY_BUTTONProps> = (props) => {
  const theme = getTheme();
  const styles = getStyles(theme);

  return (
    <div className={styles.buttonContainer}>
      <button className={styles.main} onClick={() => props.onClick()} title={props.title} aria-label={props.title}>
        <Icon iconName='OpenPane' className={styles.icon} />
      </button>
    </div>
  );
};
